// #6606: the user edit page renders a holder first from the cached cap table, then fetches the fresh record. These
// tell whether the fresh record's shares differ from what was rendered, so the page rebuilds the share cards.

/** JSON with object keys sorted, so the same data serializes the same whatever order its keys came back in. */
export function stableJson(value) {
	if (Array.isArray(value)) return `[${value.map(stableJson).join(',')}]`;
	if (value && typeof value === 'object') {
		return `{${Object.keys(value)
			.sort()
			.map((k) => `${JSON.stringify(k)}:${stableJson(value[k])}`)
			.join(',')}}`;
	}
	return JSON.stringify(value ?? null);
}

/** A fingerprint of a holder's shares in one client: their classes, balances and vesting grants. */
export function holderSharesFingerprint(holder, client) {
	return stableJson(holder?.clients?.[client]?.shares ?? null);
}
